import type { Spec } from '@globalwebindex/spec-renderer';

/** Mock artifact spec aligned with @globalwebindex/spec-renderer catalog types. */
export const artifactTestSpec: Spec = {
  root: 'grid-1',
  elements: {
    'audience-overlap-1': {
      type: 'AudienceOverlap',
      children: [],
      visible: true,
      props: {
        audienceData: [
          {
            id: '74380c62-9a63-48e4-981b-ae31dd637be3',
            title: 'Nintendo Switch users',
            percentage: 6.599999904632568,
            sample: 29674,
            universe: 170683581,
            type: 'authored'
          },
          {
            id: 'a370694d-1b55-438e-b5d7-153357262396',
            title: "Domino's visitors",
            percentage: 19.200000762939453,
            sample: 62001,
            universe: 597445756,
            type: 'authored'
          },
          {
            id: 'd1690df7-391c-472e-b35d-5ae2e4b7c462',
            title: "Nintendo Switch users x Domino's visitors",
            percentage: 1.899999976158142,
            sample: 7168,
            universe: 50336699,
            datasets: ['GWI Core'],
            type: 'instant'
          }
        ],
        stats: [
          { value: '1.9%', label: 'Overlap share' },
          { value: '50.3M', label: 'Overlap universe' },
          { value: '7,168', label: 'Overlap sample' }
        ],
        title: 'Audience overlap'
      }
    },
    'grid-1': {
      type: 'Grid',
      children: [
        'section-title-1',
        'grid-2',
        'grid-3',
        'grid-6',
        'grid-10',
        'grid-12',
        'grid-14',
        'grid-18'
      ],
      visible: true,
      props: {
        gap: 'lg',
        layout: 'vertical'
      }
    },
    'grid-10': {
      type: 'Grid',
      children: ['quote-card-2', 'grid-11'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-11': {
      type: 'Grid',
      children: ['insight-card-1', 'insight-card-2', 'insight-card-3'],
      visible: true,
      props: {
        columns: '3',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-12': {
      type: 'Grid',
      children: ['grid-13'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-13': {
      type: 'Grid',
      children: [
        'horizontal-stacked-bar-chart-1',
        'horizontal-stacked-bar-chart-2'
      ],
      visible: true,
      props: {
        columns: '2',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-14': {
      type: 'Grid',
      children: ['grid-15', 'grid-16'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-15': {
      type: 'Grid',
      children: [
        'insight-card-4',
        'insight-card-5',
        'insight-card-6',
        'insight-card-7'
      ],
      visible: true,
      props: {
        columns: '4',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-16': {
      type: 'Grid',
      children: ['grid-17'],
      visible: true,
      props: {
        columns: '1',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-17': {
      type: 'Grid',
      children: ['insight-card-8', 'insight-card-9'],
      visible: true,
      props: {
        columns: '2',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-18': {
      type: 'Grid',
      children: ['quote-card-3'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-2': {
      type: 'Grid',
      children: ['quote-card-1', 'key-points-card-1'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-3': {
      type: 'Grid',
      children: ['audience-overlap-1', 'grid-5'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-5': {
      type: 'Grid',
      children: ['radio-stat-card-1', 'radio-stat-card-2'],
      visible: true,
      props: {
        columns: '2',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-6': {
      type: 'Grid',
      children: ['grid-7', 'grid-8'],
      visible: true,
      props: {
        gap: 'md',
        layout: 'vertical'
      }
    },
    'grid-7': {
      type: 'Grid',
      children: ['radio-stat-card-3', 'radio-stat-card-4'],
      visible: true,
      props: {
        columns: '2',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-8': {
      type: 'Grid',
      children: ['grid-9'],
      visible: true,
      props: {
        columns: '1',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'grid-9': {
      type: 'Grid',
      children: ['radio-stat-card-5', 'radio-stat-card-6'],
      visible: true,
      props: {
        columns: '2',
        gap: 'md',
        layout: 'horizontal'
      }
    },
    'horizontal-stacked-bar-chart-1': {
      type: 'StackedBar',
      children: [],
      visible: true,
      props: {
        description:
          'The Nintendo Switch user base skews toward young and mid-life adults.',
        colors: ['#2563EB', '#60A5FA', '#93C5FD', '#DBEAFE'],
        data: [
          {
            index: '',
            name: '18-24',
            percentage: 22,
            value: 22
          },
          {
            index: '',
            name: '25-34',
            percentage: 33,
            value: 33
          },
          {
            index: '',
            name: '35-54',
            percentage: 27,
            value: 27
          },
          {
            index: '',
            name: '55-64',
            percentage: 17,
            value: 17
          }
        ],
        title: 'Age split'
      }
    },
    'horizontal-stacked-bar-chart-2': {
      type: 'StackedBar',
      children: [],
      visible: true,
      props: {
        description: 'The audience is close to balanced by gender.',
        colors: ['#1D4ED8', '#EC4899'],
        data: [
          {
            index: '',
            name: 'Men',
            percentage: 54,
            value: 54
          },
          {
            index: '',
            name: 'Women',
            percentage: 46,
            value: 46
          }
        ],
        title: 'Gender split'
      }
    },
    'insight-card-1': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Nintendo Switch users in the UK',
        footnote: 'prime age bracket within the Nintendo Switch user base',
        title: 'Aged 25-34',
        value: '33%'
      }
    },
    'insight-card-2': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Gender split among Nintendo Switch users',
        footnote: 'share of the Nintendo Switch user audience',
        title: 'Men',
        value: '54%'
      }
    },
    'insight-card-3': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Household income profile',
        footnote: 'share of the Nintendo Switch user base',
        title: 'High income',
        value: '6.6%'
      }
    },
    'insight-card-4': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Food delivery behaviour',
        footnote: 'in the last month',
        title: 'Ordered takeaway or takeout',
        value: '53%'
      }
    },
    'insight-card-5': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Delivery app and site usage',
        footnote: 'on any device',
        title: 'Ordered via a delivery service',
        value: '40%'
      }
    },
    'insight-card-6': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Brand-specific delivery',
        footnote: 'in the last month',
        title: 'Ordered through Uber Eats',
        value: '15%'
      }
    },
    'insight-card-7': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Deal-seeking behaviour',
        footnote: 'in the last month',
        title: 'Used coupons, deals, or price-comparison platforms',
        value: '30%'
      }
    },
    'insight-card-8': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Restaurant and retail apps',
        footnote: 'in the past month',
        title: 'Used a branded app',
        value: '23%'
      }
    },
    'insight-card-9': {
      type: 'Insight',
      children: [],
      visible: true,
      props: {
        description: 'Travel and mobility apps',
        footnote: 'showing wider app comfort beyond food delivery',
        title: 'Book transport for vacations via mobile apps',
        value: '44%'
      }
    },
    'key-points-card-1': {
      type: 'KeyPoints',
      children: [],
      visible: true,
      props: {
        description:
          "Three signals make this audience commercially attractive for Domino's.",
        items: [
          '53% of Nintendo Switch users used takeaway or takeout in the last month',
          '55% of Nintendo Switch users regularly use discount codes or coupons',
          '23% of Nintendo Switch users downloaded or used a branded app in the past month'
        ],
        title: 'Why this angle works'
      }
    },
    'quote-card-1': {
      type: 'Quote',
      children: [],
      visible: true,
      props: {
        text: "**Nintendo Switch users** are an **app-savvy, deal-responsive delivery audience** who give **Domino's** a strong route to incremental orders and longer-term loyalty."
      }
    },
    'quote-card-2': {
      type: 'Quote',
      children: [],
      visible: true,
      props: {
        text: '**The App-First Deal Seekers** are young adults with a balanced gender mix, strong delivery habits, and high comfort with branded apps.'
      }
    },
    'quote-card-3': {
      type: 'Quote',
      children: [],
      visible: true,
      props: {
        text: "For **Domino's**, the opportunity is to convert this audience's deal responsiveness into extra sales through **time-boxed app incentives, value-led bundles, and CRM nudges** aligned to peak delivery hours and gaming moments."
      }
    },
    'radio-stat-card-1': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.11 IDX',
        label: 'Ordered a meal via a food delivery service',
        percentage: 40
      }
    },
    'radio-stat-card-2': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.11 IDX',
        label: 'Use discount codes or coupons',
        percentage: 55
      }
    },
    'radio-stat-card-3': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.50 IDX',
        label: 'Downloaded or used a branded app in the past month',
        percentage: 23
      }
    },
    'radio-stat-card-4': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.15 IDX',
        label: 'Prefer shopping online when coupons or discounts are available',
        percentage: 47
      }
    },
    'radio-stat-card-5': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.60 IDX',
        label: 'Downloaded or used a branded app in the last month',
        percentage: 26
      }
    },
    'radio-stat-card-6': {
      type: 'RingStat',
      children: [],
      visible: true,
      props: {
        index: '1.12 IDX',
        label: 'Use discount codes or coupons',
        percentage: 58
      }
    },
    'section-title-1': {
      type: 'SectionTitle',
      children: [],
      visible: true,
      props: {
        text: "Domino's x Nintendo Switch Users"
      }
    }
  }
};
